import React from 'react';
import classes from './Container.module.scss';
import { Layout } from 'antd';

const Container = ({ children, style, ...props }) => {
  return (
    <Layout.Content className={`${classes.container}`} style={style} {...props}>
      {children}
    </Layout.Content>
  );
};

export default Container;
